// True when a keystroke comes from somewhere the user is typing (shortcuts must leave it alone).
export const isTypingTarget = (t) => !!t && (
  ['INPUT', 'TEXTAREA', 'SELECT'].includes(t.tagName)
  || !!t.isContentEditable
  || !!t.closest?.('[contenteditable]:not([contenteditable="false"])')
);
